import React, { Component } from 'react';
import axios from 'axios';
import './App.css';

class BonusTalepForm extends Component {
  state = {
    allData: [], // DB'den gelen kategori ve bonuslar
    bonuslar: [], // Seçilen kategoriye ait bonuslar
    bonusKategorisi: '',
    secilenBonus: '',
    talepGonderiliyor: false,
    loading: false,
    talepStatus: '',
    kullaniciAdi: '',
    bonusGeçmişi: [],
    selectedBonus: null,
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const usernameFromUrl = urlParams.get('username');
    this.setState({ kullaniciAdi: usernameFromUrl || '' }, () => {
      this.fetchInitialData(); // DB'den kategorileri ve bonusları çek
      this.fetchBonusGeçmişi();
    });

    this.interval = setInterval(this.fetchBonusGeçmişi, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // Veritabanındaki Kategorileri ve Bonusları çeker https://api.antikbet.dev:1881/
  fetchInitialData = async () => {
    const { kullaniciAdi } = this.state;
    try {
      // URL'e username parametresini ekliyoruz
      const response = await axios.get(`https://api.antikbet.dev:1881/bonus/selection-data?username=${kullaniciAdi}`);
      this.setState({ allData: response.data });
    } catch (error) {
      console.error('Bonus verileri yüklenemedi:', error);
    }
  };

  fetchBonusGeçmişi = () => {
    const { kullaniciAdi } = this.state;
    if (kullaniciAdi) {
      axios.get(`https://api.antikbet.dev:1881/request/userThreeRequest?username=${kullaniciAdi}`)
        .then((response) => this.setState({ bonusGeçmişi: response.data }))
        .catch((error) => console.error('Geçmiş hatası:', error));
    }
  };

  // Geçmiş tablosundaki bonus tipine göre isim bulur
  getBonusNameFromType = (type) => {
    // DB'den gelen data içinde bu type'ı ara
    for (const cat of this.state.allData) {
      const found = cat.items.find(b => b.type === type.toString());
      if (found) return found.name;
    }
    return type; // Bulamazsa tipi yazdır
  };

  handleBonusKategorisiChange = (event) => {
    const categoryId = event.target.value;
    // Seçilen categoryId'ye sahip objeyi allData içinden bul
    const selectedCatObj = this.state.allData.find(c => c.categoryId === parseInt(categoryId));

    this.setState({
      bonusKategorisi: categoryId,
      bonuslar: selectedCatObj ? selectedCatObj.items : [],
      secilenBonus: '',
      talepStatus: '',
    });
  }

  handleSecilenBonusChange = (event) => {
    this.setState({ secilenBonus: event.target.value });
  }

  handleTalepGonder = () => {
    const { kullaniciAdi, secilenBonus } = this.state;

    if (!kullaniciAdi || !secilenBonus) {
      this.setState({ talepStatus: 'Lütfen tüm alanları doldurun' }, this.clearNotification);
      return;
    }

    this.setState({ talepGonderiliyor: true, loading: true });

    // URL'e secilenBonus olarak DB'den gelen 'type' (1100, freespin vb.) gidiyor
    axios.post(`https://api.antikbet.dev:1881/request/add?username=${kullaniciAdi}&bonustype=${secilenBonus}`)
      .then((response) => {
        this.setState({ loading: false, talepStatus: response.data.message }, this.clearNotification);
        this.fetchBonusGeçmişi();
      })
      .catch((error) => {
        this.setState({ loading: false, talepStatus: 'Talep gönderme başarısız oldu' }, this.clearNotification);
      })
      .finally(() => this.setState({ talepGonderiliyor: false }));
  };

  clearNotification = () => {
    setTimeout(() => this.setState({ talepStatus: '' }), 5000);
  }

  getNotificationStyle = (status) => {
    const styles = {
      'Lütfen tüm alanları doldurun': { backgroundColor: '#FF5733', color: '#fff' },
      'Bekleyen talebiniz mevcuttur.': { backgroundColor: '#4682b4', color: '#fff' },
      'Talep oluşturulurken bir hata oluştu.': { backgroundColor: '#FF5733', color: '#fff' },
      'Talebiniz başarılı bir şekilde oluşturulmuştur.': { backgroundColor: '#3cb371', color: '#fff' }
    };
    return styles[status] || { backgroundColor: '#444', color: '#fff' };
  };

  render() {
    const { talepStatus, loading, talepGonderiliyor, bonusGeçmişi, allData, bonuslar } = this.state;

    return (
      <div className="container">
        <div className="form">
          <h2>AntikBet - Bonus Talep Formu</h2>

          <div className="loading-bar-container">
            {loading && <div className="loading-bar" />}
          </div>

          <h5 style={{ color: loading ? '#f27127' : 'grey' }}>
            {loading ? "Bonusunuz kontrol ediliyor..." : `Hoş geldiniz ${this.state.kullaniciAdi}, aşağıdan bonusunuzu seçiniz:`}
          </h5>

          {talepStatus && (
            <div className="notification" style={this.getNotificationStyle(talepStatus)}>
              {talepStatus}
            </div>
          )}

          <div className="form-group">
            <label className="label">Bonus Kategorisi:</label>
            <select
              className="input"
              value={this.state.bonusKategorisi}
              onChange={this.handleBonusKategorisiChange}
            >
              <option value="">Seçiniz</option>
              {allData.map(cat => (
                <option key={cat.categoryId} value={cat.categoryId}>{cat.name || cat.categoryName}</option>
              ))}
            </select>
          </div>

          {bonuslar.length > 0 && (
            <div className="form-group">
              <label className="label">Bonus Seç:</label>
              <select
                className="input"
                value={this.state.secilenBonus}
                onChange={this.handleSecilenBonusChange}
              >
                <option value="">Seçiniz</option>
                {bonuslar.map((bonus) => (
                  <option key={bonus.id} value={bonus.type}>
                    {bonus.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <button
              className="button"
              onClick={this.handleTalepGonder}
              disabled={talepGonderiliyor}
            >
              {talepGonderiliyor ? "Gönderiliyor..." : "Talebi Gönder"}
            </button>
          </div>

          <div className="bonus-talepleri-form">
            <hr className="separator" />
            <div className="bonus-gecmisi">
              <h3>Bonus Geçmişi</h3>
              {bonusGeçmişi.length === 0 ? (
                <p>Bonus geçmişiniz bulunmamaktadır.</p>
              ) : (
                <table>
                  <thead>
                    <tr>
                      <th>Bonus Türü</th>
                      <th>Durum</th>
                      <th>Talep Tarihi</th>
                      <th>İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bonusGeçmişi.map((bonus, index) => (
                      <tr key={index}>
                        <td>{this.getBonusNameFromType(bonus.bonusType)}</td>
                        <td>
                          <span className={`status-badge ${bonus.status}`}>
                            {bonus.status === 'rejected' ? 'Reddedildi' : bonus.status === 'approved' ? 'Onaylandı' : 'Beklemede'}
                          </span>
                        </td>
                        <td>{new Date(bonus.createdAt).toLocaleString()}</td>
                        <td>
                          {bonus.status === 'rejected' && (
                            <button className="show-reason-btn" onClick={() => this.setState({ selectedBonus: bonus })}>
                              Göster
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>

        {this.state.selectedBonus && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h4>Red Nedeni</h4>
              <p>{this.state.selectedBonus.rejectReason || 'Belirtilmedi'}</p>
              <button onClick={() => this.setState({ selectedBonus: null })}>Kapat</button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default BonusTalepForm;